import { render, staticRenderFns } from "./GhostRatingIndex.vue?vue&type=template&id=1bc349ce&scoped=true&"
import script from "./GhostRatingIndex.vue?vue&type=script&lang=js&"
export * from "./GhostRatingIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc349ce",
  null
  
)

export default component.exports